(function () {
  function initCarousel(root, options) {
    var viewport = root.querySelector(options.viewport);
    var track = root.querySelector(options.track);
    var items = root.querySelectorAll(options.item);
    var prevBtn = root.querySelector(options.prev);
    var nextBtn = root.querySelector(options.next);

    if (!viewport || !track || items.length <= 1) return;

    var currentIndex = 0;

    function isMobile() {
      return window.innerWidth <= 768;
    }

    function getSlidesPerView() {
      if (options.slidesPerView) return options.slidesPerView();
      return isMobile() ? 1 : Math.min(3, items.length);
    }

    function getMaxIndex() {
      return Math.max(0, items.length - getSlidesPerView());
    }

    function updateButtons() {
      var maxIndex = getMaxIndex();
      if (prevBtn) prevBtn.disabled = currentIndex <= 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
    }

    function scrollToIndex(index) {
      currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
      var item = items[currentIndex];
      if (!item) return;

      viewport.scrollTo({
        left: item.offsetLeft - track.offsetLeft,
        behavior: 'smooth',
      });

      updateButtons();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToIndex(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToIndex(currentIndex + 1);
      });
    }

    var scrollTicking = false;

    viewport.addEventListener(
      'scroll',
      function () {
        if (scrollTicking) return;
        scrollTicking = true;
        window.requestAnimationFrame(function () {
          scrollTicking = false;
          var scrollLeft = viewport.scrollLeft;
          var nearestIndex = 0;
          var nearestDistance = Infinity;

          items.forEach(function (item, index) {
            var distance = Math.abs(item.offsetLeft - track.offsetLeft - scrollLeft);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });

          currentIndex = Math.min(nearestIndex, getMaxIndex());
          updateButtons();
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', updateButtons, { passive: true });
    updateButtons();
  }

  function initResumeUpload(root) {
    var input = root.querySelector('[data-career-resume-input]');
    var zone = root.querySelector('[data-career-resume-zone]');
    var label = root.querySelector('[data-career-resume-label]');

    if (!input || !zone) return;

    zone.addEventListener('click', function () {
      input.click();
    });

    zone.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        input.click();
      }
    });

    zone.addEventListener('dragover', function (event) {
      event.preventDefault();
      zone.classList.add('is-dragover');
    });

    zone.addEventListener('dragleave', function () {
      zone.classList.remove('is-dragover');
    });

    zone.addEventListener('drop', function (event) {
      event.preventDefault();
      zone.classList.remove('is-dragover');
      if (event.dataTransfer && event.dataTransfer.files.length) {
        input.files = event.dataTransfer.files;
        updateLabel();
      }
    });

    input.addEventListener('change', updateLabel);

    function updateLabel() {
      if (!label) return;
      if (input.files && input.files.length) {
        label.textContent = input.files[0].name;
      }
    }
  }

  function initJotformCareerForm(root) {
    initResumeUpload(root);

    var nameInput = root.querySelector('[data-career-name-input]');
    var firstHidden = root.querySelector('[data-career-name-first]');
    var lastHidden = root.querySelector('[data-career-name-last]');
    var successMessage = root.querySelector('[data-career-form-success]');
    var errorMessage = root.querySelector('[data-career-form-error]');
    var submitDateInput = root.querySelector('[data-career-submit-date]');
    var spcInput = root.querySelector('[data-career-jotform-spc]');
    var resumeLabel = root.querySelector('[data-career-resume-label]');
    var formId = root.getAttribute('data-career-jotform-id');
    var submitButton = root.querySelector('.rabitat-career__submit');
    var defaultSubmitLabel = submitButton
      ? submitButton.getAttribute('data-career-submit-default') || submitButton.textContent.trim()
      : 'SUBMIT';
    var loadingSubmitLabel = submitButton
      ? submitButton.getAttribute('data-career-submit-loading') || 'Submitting...'
      : 'Submitting...';
    var defaultResumeLabel = resumeLabel ? resumeLabel.textContent.trim() : '';
    var iframeName = 'career-jotform-target-' + (formId || 'form');
    var iframe = document.createElement('iframe');
    var awaitingResponse = false;
    var responseTimeoutId = 0;

    iframe.name = iframeName;
    iframe.title = 'Form submission';
    iframe.hidden = true;
    iframe.setAttribute('tabindex', '-1');
    iframe.setAttribute('aria-hidden', 'true');
    root.appendChild(iframe);

    function setSubmitting(isSubmitting) {
      if (!submitButton) return;
      submitButton.disabled = isSubmitting;
      submitButton.textContent = isSubmitting ? loadingSubmitLabel : defaultSubmitLabel;
      if (isSubmitting) {
        submitButton.setAttribute('aria-busy', 'true');
      } else {
        submitButton.removeAttribute('aria-busy');
      }
    }

    function hideStatusMessages() {
      if (successMessage) successMessage.hidden = true;
      if (errorMessage) errorMessage.hidden = true;
    }

    function showSuccess() {
      setSubmitting(false);
      root.reset();
      if (resumeLabel) resumeLabel.textContent = defaultResumeLabel;
      hideStatusMessages();
      if (successMessage) {
        successMessage.hidden = false;
        successMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function showError() {
      setSubmitting(false);
      hideStatusMessages();
      if (errorMessage) {
        errorMessage.hidden = false;
        errorMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function prepareSubmissionFields() {
      if (nameInput && firstHidden && lastHidden) {
        var parts = nameInput.value.trim().split(/\s+/).filter(Boolean);
        firstHidden.value = parts[0] || '';
        lastHidden.value = parts.slice(1).join(' ') || '';
      }

      if (submitDateInput) {
        submitDateInput.value = new Date().toISOString();
      }

      if (spcInput && formId) {
        spcInput.value = formId + '-' + formId;
      }
    }

    iframe.addEventListener('load', function () {
      if (!awaitingResponse) return;

      awaitingResponse = false;
      window.clearTimeout(responseTimeoutId);

      var submissionFailed = false;

      try {
        var doc = iframe.contentDocument || iframe.contentWindow.document;
        var bodyText = doc && doc.body ? doc.body.textContent : '';
        submissionFailed = /request failed|please try again/i.test(bodyText || '');
      } catch (error) {
        submissionFailed = false;
      }

      if (submissionFailed) {
        showError();
        return;
      }

      showSuccess();
    });

    root.addEventListener('submit', function (event) {
      event.preventDefault();
      hideStatusMessages();
      prepareSubmissionFields();
      setSubmitting(true);
      awaitingResponse = true;
      window.clearTimeout(responseTimeoutId);
      responseTimeoutId = window.setTimeout(function () {
        if (!awaitingResponse) return;
        awaitingResponse = false;
        setSubmitting(false);
        showError();
      }, 30000);

      root.target = iframeName;
      root.submit();
    });
  }

  document.querySelectorAll('[data-career-team-carousel]').forEach(function (carousel) {
    initCarousel(carousel, {
      viewport: '[data-career-team-viewport]',
      track: '[data-career-team-track]',
      item: '[data-career-team-card]',
      prev: '[data-career-team-prev]',
      next: '[data-career-team-next]',
      slidesPerView: function () {
        return 2;
      },
    });
  });

  document.querySelectorAll('[data-career-reviews-carousel]').forEach(function (carousel) {
    initCarousel(carousel, {
      viewport: '[data-career-reviews-viewport]',
      track: '[data-career-reviews-track]',
      item: '[data-career-review-card]',
      prev: '[data-career-reviews-prev]',
      next: '[data-career-reviews-next]',
      slidesPerView: function () {
        return window.innerWidth <= 768 ? 1 : 3;
      },
    });
  });

  document.querySelectorAll('[data-career-jotform]').forEach(initJotformCareerForm);
  document.querySelectorAll('[data-career-form]:not([data-career-jotform])').forEach(initResumeUpload);
})();
